












































































































































































import { ClientAccount } from '@/shared/clients/client-account';
import { ClientRelationshipType } from '@/shared/types/client-relationship-type';
import { Validator } from 'vee-validate';
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const typesModule = namespace('types');

@Component
export default class AddClientAdditionalDetails extends Vue {
    @typesModule.Getter('activeClientRelationshipTypes') private clientRelationshipTypes!: Array<ClientRelationshipType>;

    @Inject('$validator') public $validator!: Validator;
    @Prop({ required: true }) private client!: ClientAccount;

    private onNationalInsuranceNumberChanged(nationalInsuranceNumber: string | null): void {
        this.client.nationalInsuranceNumber = nationalInsuranceNumber;
    }

    private onHasChildrenNoClicked(): void {
        this.client.hasChildrenUnderEighteen = false;
    }

    private onHasChildrenUnknownClicked(): void {
        this.client.hasChildrenUnderEighteen = null;
    }

    private onHasChildrenUnderEighteenYesClicked(): void {
        this.client.hasChildren = true;
    }
}
